import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../assets/stylesheets/Dialogs/DailyBonus.scss';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import { useDispatch } from 'react-redux';

const DailyBonus =({ amount }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
    return (
        <div className = {` `}>
            <div className = {`bitmap`}>
                <div className = {`loginBonusText`}>{t('loginBonus')}</div>
                <div className={`bonus`}>
                    <div className = {`coin`}>
                        <div className = {`coinImage`}></div>
                    </div>
                    <span className = {`coinAmount`}>{ amount }</span>
                </div>
                <div className={`cards`}>
                </div>
            </div>
            <div className={`dialogConfirmBox`}>
                <button className="primary" onClick = { () => dispatch(closeDialog('dailyBonus')) }>{t('button.claim')}</button>
            </div>
        </div> 
    );
};

export default DailyBonus;

